import { PizarraEvento } from 'src/common/pizarraEvento';
import { PizarraActions, PizarraActionTypes } from './pizarra.actions';
import { ContenidoStatus } from 'src/common/contenido';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

const PIZARRA_PAGE_SIZE: number = 5;

export interface PizarraState extends EntityState<PizarraEvento> {
	ready: boolean;
	maxEventQty: number;
	status: ContenidoStatus;
	cleared: boolean;
};

export const pizarraAdapter: EntityAdapter<PizarraEvento> = createEntityAdapter<PizarraEvento>();

const initialPizarraState: PizarraState = pizarraAdapter.getInitialState({
	ready: true,
	maxEventQty: PIZARRA_PAGE_SIZE,
	status: null,
	cleared: false
});

export function pizarraReducer( state: PizarraState = initialPizarraState, action: PizarraActions ): PizarraState {
	let payload;
	let status: ContenidoStatus;

	switch( action.type ) {
		case PizarraActionTypes.PizarraLastEventosRequested:
			return { ...state, cleared: false, ready: false };
		case PizarraActionTypes.PizarraLastEventosLoaded:
			payload = action["payload"];
			status = payload["status"];
			let eventos: PizarraEvento[] = payload["eventos"];
			
			state = pizarraAdapter.removeAll( state );

			return pizarraAdapter.addMany( eventos, {
				...state,
				ready: true,
				status,
				cleared: true
			});
		case PizarraActionTypes.PizarraCancelled:
			payload = action["payload"];
			status = payload["status"];

			// Si status == null => hubo un problema con el status, dejo el state como está
			if ( status != null && status.qty == 0 ) {
				state = pizarraAdapter.removeAll( state );
				state = { ...state, cleared: false, status };
			};

			return { ...state, ready: true };
		case PizarraActionTypes.PizarraRight:
			return { ...state, ready: true, cleared: false };
		default:
			return state;
	};
};

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = pizarraAdapter.getSelectors();